import { render, staticRenderFns } from "./uploadAndViewImg.vue?vue&type=template&id=63cbfa7c&"
import script from "./uploadAndViewImg.vue?vue&type=script&lang=js&"
export * from "./uploadAndViewImg.vue?vue&type=script&lang=js&"
import style0 from "./uploadAndViewImg.vue?vue&type=style&index=0&id=63cbfa7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports